<template>
  <div class="definition">
    <div class="definition__info definition__info--empowerment">
      <div class="info">
        <h1 class="info__title">Real Empowerment</h1>

        <dots-number activeDots='4'/>

        <div class="info text-center">
          <div class="info__header">
            <p class="info__header-text">
              The organisation carefully manages authority, decision making and autonomy to
              bring the best out of each member, fostering a spirit of entrepreneurship.
            </p>
          </div>
          <div>
            <div class="info__body text-left">
              <p class="info__body-text font-weight-bold mb-4">
                Our assessment of Real Empowerment looks at the following attributes:
              </p>
              <ol>
                <li class="info__body-text"><b>Ownership & Autonomy</b>
                   – People are encouraged throughout the organisation to take full
                   ownership of their work and feel trusted to carry it out how they see fit. </li>
                <li class="info__body-text"><b>Entrepreneurship</b>
                   – Everyone in the organisation is encouraged to explore new opportunities
                   that they identify and there is a common desire to constantly improve the organisation.</li>
                <li class="info__body-text"><b>Intrinsic Motivation</b>
                   – Each member of the organisation is motivated in what they do,
                   leading to high quality outcomes. </li>
                <li class="info__body-text"><b>Empowered Decision-Making</b>
                   – Decision-making processes are streamlined to be clear and efficient,
                   placing power as close as possible to the activities taking place.</li>
              </ol>
              <div class="info__footer pb-0">
              </div>
            </div>
          </div>
          <div class="info__footer pb-0">
            <slot></slot>
          </div>
        </div>
        <go-back-button/>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import EmpowermentInfo from '@/components/Evaluation/Empowerment/Info';
import DotsNumber from '@/components/Evaluation/Dots';
import GoBackButton from '@/components/Helpers/GoBackButton';

export default {
  components: { EmpowermentInfo, DotsNumber, GoBackButton },
  data() {
    return {
      id: 5,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Definition/Empowerment.vue